<div class="onboarding-container">
  @if (parkingSession) {
    <div class="card text-center mb-6">
      <div class="card-header">
        <div class="flex flex-col gap-4 headline-x-small">
          @if (canExitLocation) {
            <div class="flex flex-col justify-center w-full">
              <i class="icon fa-solid fa-circle-arrow-up mb-4 text-success-dark"></i>
              <span [innerText]="'SignUp.YouCanExitTheLocationNow' | translate"></span>
            </div>
          } @else {
            <div class="flex flex-col justify-center w-full">
              <i class="icon fa-solid fa-circle-check mb-4" [ngClass]="{ 'text-success-dark': !!parkingSession.exit_time }"></i>
              <span [innerText]="'SignUp.YourAccountHasBeenActivatedSuccessfully' | translate"></span>
            </div>
          }
        </div>
      </div>
      <div class="card-body">
        <arivo-license-plate
          class="block mx-auto my-4"
          [country]="parkingSession.license_plate.license_plate_country"
          [licensePlate]="parkingSession.license_plate.license_plate"
        ></arivo-license-plate>

        @if (showPayOpenAmount) {
          <div class="body-large">
            <span class="text-error" [innerText]="'SignUp.PleasePayOpenAmountBeforeExit' | translate"></span>
          </div>
        }
        @if (showDontPayTicket) {
          <div class="body-large">
            <span class="text-error" [innerText]="'SignUp.PleaseDontPayTicket' | translate"></span>
          </div>
        }

        <div class="well flex flex-col gap-2 my-6">
          <div class="flex">
            <div class="flex-grow body-medium text-neutral-50 text-left" [innerText]="'Onboarding.Start' | translate"></div>
            <div
              class="flex-grow body-medium text-neutral-10 text-right"
              [innerText]="parkingSession.entry_time | date: 'dd/MM/yy hh:mm'"
            ></div>
          </div>

          @if (parkingSession.exit_time) {
            <div class="flex">
              <div class="flex-grow body-medium text-neutral-50 text-left" [innerText]="'Onboarding.End' | translate"></div>
              <div
                class="flex-grow body-medium text-neutral-10 text-right"
                [innerText]="parkingSession.exit_time | date: 'dd/MM/yy hh:mm'"
              ></div>
            </div>
          }

          <div class="flex">
            <div class="flex-grow body-medium text-neutral-50 text-left" [innerText]="'Onboarding.Duration' | translate"></div>
            <div
              class="flex-grow body-medium text-neutral-10 text-right"
              [innerHtml]="parkingSession.duration_in_seconds | duration: 'seconds'"
            ></div>
          </div>

          @if (hasPrice) {
            <div class="flex">
              <div class="flex-grow body-medium text-neutral-50 text-left">
                @if (parkingSession.is_cleared) {
                  <strong [innerText]="'SignUp.TransferredAmount' | translate"></strong>
                } @else {
                  <strong [innerText]="'Onboarding.OpenAmount' | translate"></strong>
                }
              </div>
              <div class="flex-grow body-medium text-neutral-10 text-right">
                <strong [innerText]="parkingSession.price!.amount | localizedCurrency: parkingSession.price!.currency"></strong>
              </div>
            </div>
          }
        </div>

        @if (parkingSession.is_cleared) {
          <div class="body-medium" [innerText]="'SignUp.PleaseAddPaymentMethodBeforeNextPaymentSession' | translate"></div>
        } @else {
          <div class="body-medium" [innerText]="'SignUp.ParkingSessionCouldNotBeTransferred' | translate"></div>
        }
      </div>
    </div>
  }
  <div class="flex justify-center">
    <button class="button-primary" type="button" [innerText]="'SignUp.CompleteProfileNow' | translate" (click)="completeProfile()"></button>
  </div>
</div>
